import { Component, signal } from '@angular/core'
import { NgOptimizedImage } from '@angular/common'
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive'

@Component({
  selector: 'app-main-menu',
  standalone: true,
  imports: [NgOptimizedImage, ClickOutsideDirective],
  templateUrl: './main-menu.component.html',
  styleUrl: './main-menu.component.scss',
})
export class MainMenuComponent {
  visible = signal<boolean>(false)
}
